import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from './views/Home'
import Meta from 'vue-meta'

const About = () => import('./views/About.vue');
const Details = () => import('./views/Details.vue');
const Privacy = () => import('./views/Privacy.vue');

Vue.use(VueRouter)
Vue.use(Meta)

export const router = new VueRouter({
  mode: 'history',
  routes: [
    { 
      path : '/', 
      component : Home,
      name: 'home'
    },
    { path : '/about', 
      component : About,
      name: 'about'
    },
    {
      path: '/project/:projectSlug',
      name: 'details',
      component: Details,
      props: true
    },
    { path : '/privacy', 
      component : Privacy,
      name: 'privacy'
    },
    { 
      path: "*", // incl 404
      redirect: '/'
    }
  ]
})
